var _pattern, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "circuit",
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10 H80 M50 10 V40 M50 40 H80 M80 40 V70 M20 70 H80",
    stroke: "#4299e1",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 3,
    fill: "#4299e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 10,
    r: 3,
    fill: "#4299e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 3,
    fill: "#4299e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 3,
    fill: "#4299e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 70,
    r: 3,
    fill: "#4299e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 70,
    r: 3,
    fill: "#4299e1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#circuit)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.cbb6dcb5c55c1a4f4a44c47f0e1092e4.svg";
export { ForwardRef as ReactComponent };